import { useFirmContext } from '../providers/FirmProvider';
import { SubscriptionStatus, SubscriptionTier } from '../types/firm';

type Feature =
    | 'entity-insights-filter:read'
    | 'entity-bulk-import:write'
    | 'firm-dashboard-insights-filter:read'
    | 'firm-insights:read'
    | 'firm-descriptions:read'
    | 'group-overview-insights-filter:read'
    | 'group-bulk-import:write'
    | 'notifications:read'
    | 'user-bulk-import:write'
    | 'user-notifications:read'
    | 'user-overview-insights-filter:read'
    | 'workpaper-progress-insight:read'
    | 'workpaper-export:write'
    | 'workpaper-assign-multiple-approvers:write'
    | 'workpaper-assign-multiple-reviewers:write'
    | 'workpaper-assign-multiple-preparers:write'
    | 'workpaper-assign-guests:write'
    | 'workpaper-toggle-private:write'
    | 'workpaper-toggle-include-trial-balance:write'
    | 'worksheet-update-assignees:write';

export function useHasFeatureAccess(feature: Feature): boolean {
    const subscriptionTiers = [
        SubscriptionTier.BASIC,
        SubscriptionTier.ESSENTIAL,
        SubscriptionTier.PROFESSIONAL,
        SubscriptionTier.ENTERPRISE,
    ];
    const { subscription, subscriptionVersion } = useFirmContext();

    if (!subscription) {
        return false;
    }
    if (subscriptionVersion === 2) {
        return true;
    }

    const tierIdx = subscriptionTiers.indexOf(subscription.tier);

    switch (feature) {
        case 'entity-bulk-import:write':
        case 'firm-insights:read':
        case 'group-bulk-import:write':
        case 'notifications:read':
        case 'user-bulk-import:write':
        case 'workpaper-progress-insight:read':
        case 'workpaper-export:write':
        case 'workpaper-assign-multiple-reviewers:write':
        case 'workpaper-assign-multiple-preparers:write':
        case 'workpaper-toggle-private:write':
        case 'workpaper-toggle-include-trial-balance:write':
        case 'worksheet-update-assignees:write':
            return tierIdx >= 1;

        case 'entity-insights-filter:read':
        case 'firm-dashboard-insights-filter:read':
        case 'firm-descriptions:read':
        case 'group-overview-insights-filter:read':
        case 'workpaper-assign-multiple-approvers:write':
        case 'user-overview-insights-filter:read':
        case 'user-notifications:read':
            return tierIdx >= 2;

        case 'workpaper-assign-guests:write':
            return tierIdx >= 2 && subscription.status === SubscriptionStatus.ACTIVE;

        default:
            return true;
    }
}
